export default __webpack_public_path__ + "static/media/logo-dash.bb6df1f3.png";